// src/components/world/SceneErrorBoundary.jsx
import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

class SceneErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[SceneErrorBoundary] 3D scene crashed:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
          <Alert severity="warning" sx={{ maxWidth: 500 }} action={<Button color="inherit" size="small" onClick={this.handleReset}>Повторить</Button>}>
            <AlertTitle>3D-сцена недоступна</AlertTitle>
            {this.props.fallbackMessage || 'Не удалось инициализировать WebGL. Проверьте, что браузер поддерживает 3D-графику.'}
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default SceneErrorBoundary;
